import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getText } from 'misc/helpers';

class CookiePopup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: true
        };
    }

    render = () => {
        return (
            <div className = { this.state.show ? "cookie-popup" : "cookie-popup cookie-popup-hide" } ref="cookie-popup">
                <div className="cookie-popup-content">
                    <p>
                        {getText('_cookies_fronttext','Genom att logga in på vår webbplats godkänner du cookies för bl.a. förbättrad användarupplevelse.')}
                        &nbsp;<Link to="/cookie_info">{getText('_cookies_fronttext_readmore','Läs mer om cookies här!')}</Link>
                    </p>
                    <button className='cookie-button button-medium button-yellow' onClick={() => this.closePopup()}>
                        {getText('_cookies_fronttext_buttonIunderstand','Jag förstår')}
                    </button>
                </div>
            </div>
        );
    };

    closePopup(){
        localStorage.setItem("hide_cookie_popup", false);
        this.setState({
            show: false
        })
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

CookiePopup = connect(mapStateToProps)(CookiePopup);

export default CookiePopup;



// WEBPACK FOOTER //
// ./src/components/shared/CookiePopup.js